module.exports = __webpack_public_path__ + "img/CooperBlack.c839f2e5.svg";